export default __webpack_public_path__ + "84ad8ff4589609a072456cc096c730de.png";